import { getConfig } from '@cian/config/browser';
import React from 'react';
import { hydrate } from 'react-dom';
import { getLogger } from '@cian/logger/browser';
import { ErrorLogComponent } from '@cian/error-log-component';
import { IHeaderV1Schema } from '../../../shared/repositories/header/entities/response/HeaderV1Schema';
import { getFavorites } from '../favorites';

export const initializeGroupIcons = async (data: IHeaderV1Schema, favLink: string) => {
  const config = getConfig();
  const groupIconsElement = document.getElementById('header-icons-btn');
  const newHeaderEnabled = !!config.get<boolean>('newHeaderEnabled');

  if (groupIconsElement) {
    const { GroupIcons } = await import('../../../shared/components/GroupIcons/GroupIcons');
    const logger = getLogger();
    const subdomain = config.getStrict<string>('subdomain');
    const notificationCenterData = window.__header_notification_center_data__;
    const baseUrl = window.__header_base_url__;

    hydrate(
      <ErrorLogComponent logger={logger}>
        <GroupIcons
          favLink={favLink}
          headerData={data}
          subdomain={subdomain}
          baseUrl={baseUrl}
          newHeaderEnabled={newHeaderEnabled}
          notificationCenterData={notificationCenterData}
          getFavorites={getFavorites}
        />
      </ErrorLogComponent>,
      groupIconsElement,
    );
  }
};
